// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:10:58

export default {
  "id": "dragon-hunter",
  "slug": "dragon-hunter",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/97788b9bed344e21892f8983521fd9b9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/97788b9bed344e21892f8983521fd9b9/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Dragon Hunter",
      "description": "Choose your character, roll the dice and go on a fun adventure.\nClick on monsters - help the hero survive and defeat the legendary dragons in the clicker RPG Dragon Hunter.\nLuck and a strong phone glass will determine the fate of the dragon hunter.",
      "instructions": "The goal of the game is to visit all locations, passing them by killing monsters on your way.\nControl - touch/click.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "clicker",
        "dragon",
        "monster",
        "rpg",
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "龙猎人",
      "description": "选择你的角色，掷骰子，开始一场有趣的冒险。\n点击怪物——帮助英雄生存并击败传奇龙族，在点击RPG游戏《龙猎人》中。\n运气和坚固的手机屏幕将决定龙猎人的命运。",
      "instructions": "游戏目标是访问所有地点，通过杀死路上的怪物来完成。\n控制方式：触摸/点击。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "点击器",
        "龙",
        "怪物",
        "角色扮演游戏",
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "龍獵者",
      "description": "選擇你的角色，拋骰子，開啟一段有趣的冒險。\n點擊怪物 - 協助英雄生存並擊敗傳說中的龍族在點擊式RPG遊戲《龍獵人》中。\n運氣和堅固的防護玻璃將決定龍獵人的命運。",
      "instructions": "遊戲的目標是造訪所有地點，透過殺死路上的怪物來通過它們。\n控制方式 - 觸碰/點擊。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "點擊器",
        "龍",
        "怪物",
        "角色扮演遊戲",
        "時間消磨者"
      ]
    },
    "zh-HK": {
      "title": "龍騎士",
      "description": "選擇你的角色，搖動骰子，踏上愉快冒險之旅。\n點擊怪物 - 帮助英雄生存並擊敗傳說中的龍，在點擊RPG遊戲《龍獵》中。\n運氣和堅固的手機玻璃將決定龍獵者的命運。",
      "instructions": "遊戲目標為遊覽所有地點，在途經時擊敗怪物。\n控制方式 - 摸觸/點擊。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "點擊器",
        "龍",
        "怪物",
        "角色扮演遊戲",
        "時間消磨者"
      ]
    },
    "ja": {
      "title": "ドラゴンハンター",
      "description": "キャラクターを選び、サイコロを振り、楽しい冒険に出かけよう。\nモンスターをクリックして、ヒーローを助け、クリッカーゲームのDragon Hunterで伝説のドラゴンを倒そう。\n運気と強いスマートフォンのガラスがドラゴンハンターの運命を決定する。",
      "instructions": "ゲームの目的は、全ての場所を訪れ、道中のモンスターを倒しながら通過することです。\n操作 - タッチ/クリック。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "クリッカーレス",
        "ドラゴン",
        "モンスター",
        "RPG",
        "タイムキラー"
      ]
    },
    "ko": {
      "title": "드래곤 헌터",
      "description": "캐릭터를 선택하세요, 주사위를 굴려 재미있는 모험에 떠나세요.\n몬스터를 클릭하세요 - 영웅이 살아남고 클리커 RPG Dragon Hunter에서 전설적인 드래곤을 물리치세요.\n운명은 운과 강력한 휴대폰 유리로 결정됩니다.",
      "instructions": "게임의 목표는 모든 장소를 방문하여 그곳을 지나가면서 몬스터를 죽이는 것입니다.\n제어 방법 - 터치/클릭.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "클릭러",
        "드래곤",
        "몬스터",
        "RPG",
        "타임키러"
      ]
    },
    "fr": {
      "title": "Chasseur de dragons",
      "description": "Choisissez votre personnage, lancez les dés et partez en une aventure amusante.\nCliquez sur les monstres - aidez le héros à survivre et à vaincre les dragons légendaires dans le RPG au clic Dragon Hunter.\nLe hasard et une vitre de téléphone solide détermineront le sort du chasseur de dragons.",
      "instructions": "L'objectif du jeu est de visiter tous les lieux, en les passant en tuant les monstres sur le chemin.\nContrôle - toucher/clic.",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "clic",
        "dragon",
        "monstre",
        "RPG",
        "temps-kill"
      ]
    }
  }
};
